<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Number -->
    <building-number-field
      v-model="$attrs.building.number"
      :error="$attrs.errors.building.number"
    />

    <!-- Contract number prefixes -->
    <contract-number-prefixes-field
      v-model="$attrs.building.contract_number_prefixes"
      :error="$attrs.errors.building.contract_number_prefixes"
    />

    <!-- Address -->
    <address-field
      v-model="$attrs.building.address"
      :error="$attrs.errors.building.address"
      v-show="!(formType == 'add' && $attrs.building.address)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import buildingNumberField from '@/components/forms/building/fields/BuildingNumber'
import contractNumberPrefixesField from '@/components/forms/building/fields/ContractNumberPrefixes'
import addressField from '@/components/forms/building/fields/Address'

export default {
  name: 'building-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    buildingNumberField,
    contractNumberPrefixesField,
    addressField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// BuildingBlankForm.vue?0d4d2872